import { routerReducer as router } from 'react-router-redux';

const rootReducer = router;

export default rootReducer;